import React from "react";
import styled from "styled-components";

const Input = ({ icon = null, className, ...props }) => (
  <InputWrapper className={className}>
    <InputStyled {...props} />
    {icon}
  </InputWrapper>
);


const InputWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
`;

const InputStyled = styled.input`
  flex: 1;
  outline: 0;
  border-width: 0;
  padding: 12px 10px;
  box-sizing: border-box;
  min-width: 0;

  :disabled {
    background-color: #eeeeee;
  }
`;

export default Input;
